import { useCallback } from "react";
import { useSaveBarSafeNavigate } from "../../../hooks/useSaveBarSafeNavigate.js";
import { Modal, Stack, Text } from "@shopify/polaris";

import { closeModal } from "../../../store/features/modal.js";
import { resetAction } from "../../../store/features/action.js";
import { OPEN_MODAL_DONE } from "../../../constants/modalTypes.js";
import { done_modal_image } from "../../../assets//index.js";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux.js";

const DoneModal = () => {
  const navigate = useSaveBarSafeNavigate();
  const dispatch = useAppDispatch();
  const { isOpen, modalType } = useAppSelector((state) => state.modal);

  const handleClose = useCallback(() => {
    dispatch(resetAction());
    dispatch(closeModal());
    navigate("/dashboard");
  }, []);

  return (
    <Modal
      open={isOpen && modalType === OPEN_MODAL_DONE}
      onClose={handleClose}
      title="Done!"
      primaryAction={{
        content: "Continue to Dashboard",
        onAction: handleClose,
      }}
    >

      <Modal.Section>
        <div style={{ maxWidth: "340px", margin: "0 auto" }}>
          <Stack vertical distribution={"center"} alignment={"center"}>
            <Text as={"p"} variant={"bodyMd"} alignment={"center"}>
              Your action will now appear in your Stockhide Dashboard where you'll be able to see stats, update it, edit
              it or delete it in the future.
            </Text>
            <div style={{ width: "180px", height: "180px" }}>
              <img src={done_modal_image} alt={"done_modal_image"} />
            </div>
          </Stack>
        </div>
      </Modal.Section>
    </Modal>
  );
};

export default DoneModal;